var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHidePasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.b{stroke:#a9a9a9;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.627 2.627)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.894,14.611a7.665,7.665,0,0,1-4.521,1.568C4.045,16.179,1,10.089,1,10.089A14.044,14.044,0,0,1,4.852,5.568M7.775,4.183A6.942,6.942,0,0,1,9.373,4c5.328,0,8.373,6.089,8.373,6.089A14.082,14.082,0,0,1,16.1,12.518M10.987,11.7A2.284,2.284,0,1,1,7.759,8.476",
    transform: "translate(0 -0.716)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 16,
    y2: 16,
    transform: "translate(1.373 1.373)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePasswordIcon);
export default __webpack_public_path__ + "static/media/hide-password-icon.2612d0fefcb4201c5a97b6d169e93fbe.svg";
export { ForwardRef as ReactComponent };